import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ChevronDown, ChevronRight, Check, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export default function LaunchChecklist() {
  const [data, setData] = useState(null);
  const [openSection, setOpenSection] = useState(0);

  const load = async () => {
    const { data } = await api.get("/success/checklist");
    setData(data);
  };
  useEffect(() => { load(); }, []);

  const toggle = async (id, done) => {
    await api.put(`/success/checklist/${id}`, { done: !done });
    load();
  };

  const saveNote = async (id, note) => {
    await api.put(`/success/checklist/${id}`, { note });
    toast.success("Saved");
  };

  if (!data) return <div className="text-slate-500">Loading…</div>;

  return (
    <div className="max-w-4xl">
      <div className="mb-6">
        <div className="eyebrow mb-2">Success Center</div>
        <h1 className="font-display text-3xl font-bold text-navy">Agency Launch Checklist</h1>
        <p className="text-sm text-slate-500 mt-1">Everything you need to legally launch and operate your recruiting agency.</p>
      </div>

      <div className="border border-slate-200 rounded-xl bg-white p-6 mb-6">
        <div className="flex justify-between items-center mb-2">
          <div className="font-display font-semibold text-navy">Overall progress</div>
          <div className="text-sm text-slate-500">{data.completion.done} / {data.completion.total} tasks</div>
        </div>
        <div className="h-3 bg-slate-100 rounded-full overflow-hidden">
          <div className="h-full bg-gold transition-all" style={{ width: `${data.completion.percent}%` }} />
        </div>
        <div className="text-right text-xs text-slate-500 mt-1">{data.completion.percent}% complete</div>
      </div>

      <div className="space-y-3">
        {data.sections.map((s, i) => (
          <div key={s.section} className="border border-slate-200 rounded-xl bg-white overflow-hidden">
            <button onClick={() => setOpenSection(openSection === i ? -1 : i)}
              className="w-full flex items-center justify-between p-4 hover:bg-slate-50">
              <div className="flex items-center gap-3">
                {openSection === i ? <ChevronDown className="w-4 h-4 text-slate-400" /> : <ChevronRight className="w-4 h-4 text-slate-400" />}
                <div className="font-display font-semibold text-navy">{s.section}</div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-24 h-2 bg-slate-100 rounded-full overflow-hidden">
                  <div className="h-full bg-navy" style={{ width: `${s.percent}%` }} />
                </div>
                <div className="text-xs text-slate-500 w-12 text-right">{s.percent}%</div>
              </div>
            </button>
            {openSection === i && (
              <div className="border-t border-slate-100 divide-y divide-slate-100">
                {s.items.map(it => (
                  <div key={it.id} className="p-4 flex items-start gap-3">
                    <button onClick={() => toggle(it.id, it.done)}
                      className={`mt-0.5 h-5 w-5 rounded border grid place-items-center flex-shrink-0 ${it.done ? "bg-gold border-gold text-navy" : "border-slate-300"}`}>
                      {it.done && <Check className="w-3 h-3" />}
                    </button>
                    <div className="flex-1">
                      <div className={`text-sm ${it.done ? "line-through text-slate-400" : "text-slate-700"}`}>{it.title}</div>
                      {it.resource && (
                        <a href={it.resource} target="_blank" rel="noreferrer" className="text-xs text-navy hover:text-gold inline-flex items-center gap-1 mt-1">
                          Resource <ExternalLink className="w-3 h-3" />
                        </a>
                      )}
                      <input defaultValue={it.note} onBlur={e => e.target.value !== it.note && saveNote(it.id, e.target.value)}
                        placeholder="Add a note…"
                        className="mt-2 w-full text-xs text-slate-600 border-b border-transparent focus:border-slate-200 outline-none py-1" />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
